import React from "react";
import {
  Container,
  Item,
  ItemImage,
  ItemLinkIcon,
  ItemLabelWrapper,
  ItemLabel,
  ItemsWrapper,
  SectionTitle,
} from "./styles";
import useCurrentDevice from "../../utils/useCurrentDevice";
import { Devices } from "../../consts/devices";
import LearnMoreBtn from "../LearnMoreBtn";

const ImageTiles = ({
  sectionTitle,
  ImageTilesList = [],
  background,
  fontColor,
  ctaBtnUrl,
  ctaBtnLabel,
  ctaBtnType,
  ctaOpenInNewTab,
}) => {
  const currentDevice = useCurrentDevice();
  const isMobileOrTablet = [Devices.MOBILE, Devices.TABLET].includes(
    currentDevice
  );

  return (
    <Container background={background} font_color={fontColor}>
      <SectionTitle
        data-aos="fade-in"
        data-aos-duration="1000"
        data-aos-easing="ease-in"
        data-aos-once="true"
      >
        {sectionTitle}
      </SectionTitle>
      <ItemsWrapper>
        {ImageTilesList?.map(({ label, linkUrl, image }, index) => {
          return (
            <Item
              key={`${label}-${index}`}
              data-aos="fade-in"
              data-aos-offset={isMobileOrTablet ? 200 : 300}
              data-aos-delay={isMobileOrTablet ? 200 : ((index + 1) % 7) * 200}
              data-aos-duration="300"
              data-aos-easing="ease-in"
              data-aos-once="true"
              to={linkUrl}
            >
              <ItemImage item={image} />
              <ItemLabelWrapper>
                <ItemLabel>{label}</ItemLabel>
                <ItemLinkIcon type={"ChevronRight"} />
              </ItemLabelWrapper>
            </Item>
          );
        }) || null}
      </ItemsWrapper>
      {ctaBtnUrl && (
        <LearnMoreBtn
          btnUrl={ctaBtnUrl}
          btnType={ctaBtnType}
          openInNewTab={ctaOpenInNewTab}
        >
          {ctaBtnLabel}
        </LearnMoreBtn>
      )}
    </Container>
  );
};

export default ImageTiles;
